import { Component, Input, OnInit } from '@angular/core';
import { ITechnicalSkill } from '../../../../Models/interfaces/ITechnicalSkill';

@Component({
  selector: 'app-technical-skills-card',
  templateUrl: './technical-skills-card.component.html',
  styleUrls: ['./technical-skills-card.component.css']
})
export class TechnicalSkillsCardComponent implements OnInit {

  @Input() technicalSkill: ITechnicalSkill;

  constructor() { }

  ngOnInit(): void {
  }

}
